'use client';

import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import { useQuery } from '@apollo/client/react';

import { SearchProvider, type Feature } from '@contexts/search-context';
import {
  type SearchInitParams,
  buildSearchInitParams,
} from '@contexts/search-context-utils';
import { FeaturesListAllForSearchFiltersDocument } from '@gql';
import { MobileSearchModalProvider } from '@components/mobile-search-modal';

interface SearchPageShellProps {
  accountId?: string;
  placeName?: string;
  children?: React.ReactNode;
}

export function SearchPageShell({
  accountId,
  placeName,
  children,
}: SearchPageShellProps) {
  const searchParams = useSearchParams();
  const [initParams] = React.useState<SearchInitParams>(() =>
    buildSearchInitParams(new URLSearchParams(searchParams.toString()))
  );

  const { data: featuresData } = useQuery(
    FeaturesListAllForSearchFiltersDocument
  );

  const features: Feature[] =
    (featuresData?.featuresListAllForSearchFilters as Feature[]) ?? [];

  return (
    <MobileSearchModalProvider>
      <SearchProvider
        accountId={accountId}
        allFeatures={features}
        cursorAfter={initParams.cursorAfter}
        cursorBefore={initParams.cursorBefore}
        pageSize={initParams.pageSize}
        initActiveFeatures={initParams.initActiveFeatures}
        initAdultCount={initParams.initAdultCount}
        initCheckInDate={initParams.initCheckInDate}
        initCheckOutDate={initParams.initCheckOutDate}
        initChildCount={initParams.initChildCount}
        initInfantCount={initParams.initInfantCount}
        initMapCoordinates={initParams.initMapCoordinates}
        initMapZoom={initParams.initMapZoom}
        initMinNumberOfBathrooms={initParams.initMinNumberOfBathrooms}
        initMinNumberOfBeds={initParams.initMinNumberOfBeds}
        initMinNumberOfRooms={initParams.initMinNumberOfRooms}
        initMinPrice={initParams.initMinPrice}
        initMaxPrice={initParams.initMaxPrice}
        initPetCount={initParams.initPetCount}
        initPropertyTypes={initParams.initPropertyTypes}
        placeId={initParams.placeId}
        placeName={placeName}
      >
        {children}
      </SearchProvider>
    </MobileSearchModalProvider>
  );
}
